function sliderDesktop() {
  const slider = document.querySelector('.js-slider-desktop');
  if (Boolean(slider)) {
    let buttonsSlider = slider.querySelectorAll('.media-dot__item');
    let imgsSlider = slider.querySelectorAll(`li.product__media-item`);
    let elementoInicioViewport = null;
    imgsSlider.forEach((elemento) => {
      if (estaEnInicioViewport(elemento) && !elementoInicioViewport) {
        elementoInicioViewport = elemento;
      }
    });
    if (elementoInicioViewport) {
      buttonsSlider.forEach(item => item.classList.remove('is-selected'));
      slider.querySelector(`.media-dot__item[data-media="${elementoInicioViewport.dataset.mediaId}"]`).classList.add('is-selected');
    }
    buttonsSlider.forEach((btn) => {
      btn.addEventListener('click', function() {
        const mediaId = this.getAttribute('data-media');
        buttonsSlider.forEach(item => item.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        const targetImg = slider.querySelector(`li.product__media-item[data-media-id="${mediaId}"]`);
        if (targetImg) {
          targetImg.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
}
const estaEnInicioViewport = (elemento) => {
  const rect = elemento.getBoundingClientRect();
  return rect.bottom > 100;
};
document.addEventListener("DOMContentLoaded", (event) => {
  sliderDesktop();
});
document.addEventListener('scroll', function() {
  sliderDesktop();
});
